import { render, staticRenderFns } from "./InvoicesSettings.vue?vue&type=template&id=d49042ae&"
import script from "./InvoicesSettings.vue?vue&type=script&lang=js&"
export * from "./InvoicesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports